import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GroupItemDetailRes } from "core/http/service/personnelInformation/resTypes";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: GroupItemDetailRes;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {},
};

const getHistoryDetailSlice = createSlice({
  name: "getHistoryDetail",
  initialState,
  reducers: {
    getHistoryDetailStart: (state, action: PayloadAction<string>) => {
      state.status = ReduxStateType.LOADING;
    },
    getHistoryDetailSuccess: (
      state,
      action: PayloadAction<GroupItemDetailRes>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getHistoryDetailFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetHistoryDetail: () => {
      return { ...initialState };
    },
  },
});

export const {
  getHistoryDetailStart,
  getHistoryDetailSuccess,
  getHistoryDetailFailed,
  resetHistoryDetail,
} = getHistoryDetailSlice.actions;

export default getHistoryDetailSlice.reducer;
